import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import AutoplayModel from "../../../core/src/model/AutoplayModel";
import Locale from "../../../core/src/utils/Locale";
import PointerEvents from "../../../core/src/const/PointerEvents";
import MessagePopup from "../../../core/src/ui/popups/MessagePopup";

export default class VendorAutoplayLimitPopup extends MessagePopup {

    public show() {
        super.show();
        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open").interactive = true;
        let text;
        switch (AutoplayModel.autoSpinLimitReached) {
            case 'total_win':
                text = 'stop_autoplay_total_win_limit';
                break;
            case 'win':
                text = 'stop_autoplay_single_win_limit';
                break;
            case 'loss':
                text = 'stop_autoplay_loss_limit';
                break;
            case 'any_win':
                text = 'stop_autoplay_any_win';
                break;
            case 'feature':
                text = 'stop_autoplay_on_feature';
                break;
            case 'big_win':
                text = 'stop_autoplay_on_big_win';
                break;
            default:
                break;
        } 
        this.setText(Locale.getString(text));
        this.setTitle(Locale.getString("gui_lbl_autoplay_settings"));

        AutoplayModel.autoSpinLimitReached = null;
    }

    public hide() {
        ViewManager.getLayer(DefaultLayers.SplashOverlay).clear();
        super.hide();
    }
}